export enum UserGroup {
    LIST_OWNER = "ListOwner",
    LIST_ADMIN = "ListAdmin",
    LICENSEE = "Licensee",
}

export const UserGroupDisplay: Record<UserGroup, string> = {
    [UserGroup.LIST_OWNER]: "ListOwner",
    [UserGroup.LIST_ADMIN]: "Broker",
    [UserGroup.LICENSEE]: "Licensee",
};
